import './App.css';
import {BrowserRouter,Route, Routes} from 'react-router-dom'
import React from 'react';
import Home from './Components/homepage/Home';
import CheckoutPage from './Components/homepage/CheckoutPage';
import {Courses} from './Components/Courses/Courses'
import Login from './Components/Courses/Login'
import MyProducts from './Components/Courses/MyProducts'
import Dashboard from './Components/Courses/Dashboard'
import AdminDashboard from './Components/Courses/AdminDashboard'
import { useEffect } from 'react';
function App() {
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.ctrlKey && event.key === 'a') {
        event.preventDefault();
      }
    };
    const handleMouseDown = (event) => {
      event.preventDefault();
    };
    window.addEventListener('keydown', handleKeyDown);
    document.addEventListener('mousedown', handleMouseDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('mousedown', handleMouseDown);
    };
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path='/*' element={<Home/>}/>
        <Route path='/checkout' element={<CheckoutPage/>}/>
        {/* <Route path='/corfguuidsvgfwefcyvtgwafdyuewscgdtyesfewgtwrv' element={<Courses/>}/> */}
        <Route path='/corfguuidsvgfwefcyvtgwafdyuewscgdtyesfewgtwrv' element={<Login/>}/>
        <Route path='/MyProducts' element={<MyProducts/>}/>
        <Route path='/Dashboard' element={<Dashboard/>}/>
        <Route path='/AdminDashboard' element={<AdminDashboard/>}/>
      </Routes>
    </BrowserRouter>
  );
}

export default App;